import { useEffect, useRef, useState } from 'react';

export const useElementOffsetHeight = () => {
  const elementRef: any = useRef<any>();
  const [elementOffsetHeight, setElementOffsetHeight] = useState<number>(0);
  useEffect(() => {
    setElementOffsetHeight(elementRef?.current?.offsetHeight);
  }, [elementRef?.current?.offsetHeight]);

  return [elementRef, elementOffsetHeight];
};
